import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { GetCompaniesByUserId } from "./getCompanies";

export class ChangeAccountingAuto {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly query_dispatcher: QueryDispatcher,
    private readonly frontend,
  ) {}

  async run(user_id:number, company_id: number, accounitng_auto: boolean): Promise<void> {
    let args = {
      company_id:company_id,
      accounitng_auto:accounitng_auto
    }
    try {
      this.frontend.change_loading_status(company_id, true)
      await this.dispatcher.dispatch('change_accounting_auto', args)
    } catch(error) {
      console.error('Error while changeing accounting auto to comapny with id: '+company_id+' ', error)
    }
    this.frontend.change_loading_status(company_id, false)
    await new GetCompaniesByUserId(this.query_dispatcher, this.frontend).run(user_id)

  }
}